import axios from "axios"

export const getFolders = async (params = {}) => {
  return await axios.get("/documentations/folders/", { params })
}

export const createFolder = async (payload = {}) => {
  return await axios.post(`/documentations/folders/`, payload)
}

export const deleteFolder = async id => {
  return await axios.delete(`/documentations/folders/${id}/`)
}

export const updateFolder = async (id,payload) => {
  return await axios.patch(`/documentations/folders/${id}/`, payload)
}
